// extracted by mini-css-extract-plugin
export const featureItem = "featureItem-module--featureItem--37xfF";
export const itemIcon = "featureItem-module--itemIcon--3ckuQ";
export const itemText = "featureItem-module--itemText--1ZzBO";
export const featureItemSlide = "featureItem-module--featureItemSlide--12AZy";
export const itemSlideImageWrap = "featureItem-module--itemSlideImageWrap--1o_Zs";
export const itemSlideImage = "featureItem-module--itemSlideImage--1JheH";
export const itemSlideIcon = "featureItem-module--itemSlideIcon--3U6su";
export const itemSlideText = "featureItem-module--itemSlideText--3ZcOX";